
import React, {Component} from 'react'

export default class CriteriaRow extends Component {
  constructor(props){
    super(props);

    this.state = { where: this.props.data, tags: this.props.tags, brands: this.props.brands, product_collections: this.props.product_collections};

    this.fieldSelect = this.fieldSelect.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.rowHasChanged = this.rowHasChanged.bind(this);

    this.operatorChange = this.operatorChange.bind(this);
    this.tagOperator = this.tagOperator.bind(this);
    this.brandOperator = this.brandOperator.bind(this);
     this.productCollectionOperator = this.productCollectionOperator.bind(this);
    this.renderOperator = this.renderOperator.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.rowDeleted = this.rowDeleted.bind(this);
  }

  componentDidMount(){

    var t = this;
    if(t.state.where.field == "tag"){

      if(t.state.tags.length < 1){
        $.ajax({
          method: 'GET',
          url: Routes.rmrc_ad_all_tags_path(),
          dataType: 'JSON',
          success: function(data){

            t.setState({ tags: data["tags"] }); 
          }
        });
      }
    }
   else if(t.state.where.field == 'product_collection'){
    if (t.state.product_collections.length < 1){
        $.ajax({
          method: 'GET',
          url: Routes.rmrc_ad_all_product_collections_path(),
          dataType: 'JSON',
          success: function(data){
            
            t.setState({ product_collections: data["product_collections"] }); 
          }
        });
      }

    }

   else if(t.state.where.field == 'brand'){
    if (t.state.brands.length < 1){
        $.ajax({
          method: 'GET',
          url: Routes.rmrc_ad_all_brands_path(),
          dataType: 'JSON',
          success: function(data){
            
            t.setState({ brands: data["brands"] }); 
          }
        });
      }

    }

   }
  

  handleFieldChange(event){
    var w = this.state.where;
    w.field = event.target.value
    if(w.field == "tag"){
      w.operator = "tagged";
    }

    if (w.field == 'product_collection'){
      w.operator = "in_collection";
    }
    this.setState({where: w});
    this.rowHasChanged();


    var t = this;
    if(w.field == "tag" || w.field == "product_collection" || w.field == 'brand'){
      let state_obj = {}
      state_obj[w.field + 's'] = t.props['reload_' + w.field + 's']();
      t.setState(state_obj);
    }
  }

  rowHasChanged(){
    this.props.updateRow(this.state.where);
  }

  rowDeleted(event){
    this.props.removeRow(this.state.where);
  }


  handleValueChange(event){
    var w = this.state.where;
    w.value = event.target.value
    this.setState({where: w});
    this.rowHasChanged();
  }

  operatorChange(event){
    var w = this.state.where;
    w.operator = event.target.value
    this.setState({where: w});
    this.rowHasChanged();
  }

  tagOperator(row){
    var t = this;
        return (
          <select onChange={t.operatorChange} className="form-control" value={t.state.where.operator}>
            <option value="tagged">Tagged With</option>
            <option value="not_tagged">Not Tagged With</option>
          </select>
        );
  }

    brandOperator(row){
    var t = this;
        return (
          <select onChange={t.operatorChange} className="form-control" value={t.state.where.operator}>
            <option value="equals">Equals (matches exactly)</option>
          </select>
        );
  }


    productCollectionOperator(row){
    var t = this;
        return (
          <select onChange={t.operatorChange} className="form-control" value={t.state.where.operator}>
            <option value="in_collection">In Collection</option>
            <option value="not_in_collection">Not In Collection</option>
          </select>
        );
  }

  renderOperator(){
    var t = this;

    if(t.state.where.field == "tag"){
      return t.tagOperator();
    }

    else if (t.state.where.field == "product_collection"){
      return t.productCollectionOperator();
    }

    else if (t.state.where.field == 'brand'){
      return t.brandOperator();
    }
    else
    {
      return (
        <select onChange={t.operatorChange} className="form-control" value={t.state.where.operator}>
          <option value="equals">Equals (matches exactly)</option>
          <option value="not_equals">Is Not Equal To</option>
          <option value="contains">Contains</option>
          <option value="not_contains">Does Not Contain</option>
          <option value="greater">Is Greater Than</option>
          <option value="lesser">Is Less Than</option>
          <option value="between">Is Between</option>
          <option value="like">Like Expression</option>
          <option value="raw">Using SQL</option>
        </select>
      );
    }
  }

  renderValue(){
    var t = this;
    let default_option = (<option key="0" value="0">-- Choose --</option>);
    if(t.state.where.field == "tag" || t.state.where.field == "product_collection" || t.state.where.field == 'brand'){
      
      var options = t.state[t.state.where.field + 's'].map(function (t){
        return (
          <option key={t.id} value={t.id} >{t.name}</option>
        );
        });
       options.unshift(default_option);

       if (t.state[t.state.where.field + 's'].length < 1 ){
        var options = [
          (
            <optgroup key="nope" label="No options available"></optgroup>
          )
        ]
      }
       return (<select onChange={t.handleValueChange} className="form-control" value={t.state.where.value}>
        {options}
        </select>);
    }

    else {
      return (
        <input type="text" defaultValue={t.state.where.value} onChange={t.handleValueChange} className="form-control" ></input>
      );
    }
  }

  fieldSelect(){
    let t = this;
    let field_options = t.props.criteriaFields.map(function(t, i){
      return (
      <option key={i} value={t.value}>{t.display}</option>
      );
    });
    return (
      <select onChange={t.handleFieldChange} className="form-control" value={t.state.where.field}>
      <option value="">-----</option>
      {field_options}

      </select>
    );

    // would like to have Brand in here but need to load the brands from the api and fill the drop down to do that.
  }


  render (){
    var t = this;
    return (
      <tr key={t.state.where.key}>
      <td>{t.fieldSelect()}</td>
      <td>{t.renderOperator()}</td>
      <td>{t.renderValue()}</td>
      <td><button className="btn btn-danger" onClick={t.rowDeleted} ><i className="glyphicon glyphicon-trash"></i></button></td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/components/criteria_row.jsx